module.exports = __webpack_public_path__ + "img/bg24.63e25c8f.png";